import React from "react";
import { SuccessAlert } from "@worthy-npm/clarity";
import { getShipBackText } from "./helpers";
import { RETURN_PAYMENT_WAITING } from "../../../helpers/ApplicationHelper";

function ShipBackNeedOTPVerificationSuccessAlert(props) {
  const {
    item: {
      shipback_info: {
        shipping_option,
        document_id,
        isSellerAddressChanged,
        bundle_workflow_state,
      },
    },
  } = props;

  if (
    isSellerAddressChanged &&
    shipping_option === "direct" &&
    bundle_workflow_state === RETURN_PAYMENT_WAITING &&
    !!document_id
  ) {
    return (
      <div className="shipBack--alert-wrapper">
        <SuccessAlert
          onClose={() => {}}
          TextComponent={() => (
            <div
              dangerouslySetInnerHTML={{
                __html: getShipBackText("bannerNeedOTPVerification"),
              }}
            />
          )}
        />
      </div>
    );
  }

  return null;
}

export default ShipBackNeedOTPVerificationSuccessAlert;
